<template>
    <div class="radial-bar-chart">
        <apexcharts
            type="radialBar"
            ref="apexChart"
            :options="options"
            :series="series"
            :height="height"
            :width="width">
        </apexcharts>
    </div>
</template>
<script>
    import VueApexCharts from 'vue-apexcharts';

    export default {
        name: 'design-2021-apprentice-radial-bar-chart-component',
        components: {
            apexcharts: VueApexCharts,
        },
        props: {
            series: {
                type: Array,
                default: null,
            },
            options: {
                type: Object,
                default: null,
            },
            width: {
                type: String,
                default: '125',
            },
            height: {
                type: String,
                default: '125',
            },
            text: {
                type: String,
                required: false,
                default: null,
            },
        },
    };
</script>

<style scoped lang="scss">
    .radial-bar-chart ::v-deep {
        height: auto;

        .apexcharts-canvas .apexcharts-svg {
            width: inherit;
        }

        .apexcharts-inner {
            transform: none;
        }
    }
</style>
